import { render, staticRenderFns } from "./ExerciseDetailsModal.vue?vue&type=template&id=04cb4e60&"
import script from "./ExerciseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports